<template>
  <div class="flex items-center justify-center font-normal text-gray-600 h-big">
    <slot></slot>
  </div>
</template>
<script lang="ts" setup></script>
